import { LocationData } from '../types';

interface DefaultPan {
  on_plan: boolean;
  title: string;
  url_ending: string;
}

export enum SnapTrapStatus {
  SET = 'set',
  NO_SET = 'not_set',
  TRIPPED_EMPTY = 'tripped_empty',
  TRIPPED_CAUGHT = 'tripped_caught',
  DARK = 'dark',
}

export interface SmartSnapTrapData {
  id: number;
  sequence_number: string;
  serial_number: string;
  slug: string;
  default_plan: DefaultPan | null;
  last_connect?: string;
  connection_status: string;
  snap_1_status: SnapTrapStatus;
  snap_2_status: SnapTrapStatus;
  status: string;
  time_from_last_activity: string;
  battery_percentage: number;
  qr_code: string;
  location: LocationData;
}
